var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAcommodations(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 14,
    viewBox: "0 0 20 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.03125 9.21875H9.0625V4.76562C9.0625 3.88672 9.79492 3.125 10.7031 3.125H15.8594C17.793 3.125 19.375 4.70703 19.375 6.64062V12.9688C19.375 13.3789 19.0527 13.6719 18.6719 13.6719C18.2617 13.6719 17.9688 13.3789 17.9688 12.9688V10.625H2.03125V12.7344C2.03125 13.1445 1.70898 13.4375 1.32812 13.4375C0.917969 13.4375 0.625 13.1445 0.625 12.7344V1.01562C0.625 0.634766 0.917969 0.3125 1.32812 0.3125C1.70898 0.3125 2.03125 0.634766 2.03125 1.01562V9.21875ZM15.8594 4.53125H10.7031C10.5566 4.53125 10.4688 4.64844 10.4688 4.76562V9.21875H17.9688V6.64062C17.9688 5.49805 17.002 4.53125 15.8594 4.53125ZM8.125 5.70312C8.125 7.13867 6.95312 8.28125 5.54688 8.28125C4.11133 8.28125 2.96875 7.13867 2.96875 5.70312C2.96875 4.29688 4.11133 3.125 5.54688 3.125C6.95312 3.125 8.125 4.29688 8.125 5.70312ZM5.54688 4.53125C4.87305 4.53125 4.375 5.05859 4.375 5.70312C4.375 6.37695 4.87305 6.875 5.54688 6.875C6.19141 6.875 6.71875 6.37695 6.71875 5.70312C6.71875 5.05859 6.19141 4.53125 5.54688 4.53125Z",
    fill: "#202021"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAcommodations);
export default __webpack_public_path__ + "static/media/acommodations.e4df8af66b75bb1a45ac393cec068281.svg";
export { ForwardRef as ReactComponent };